import React from "react";
import { Switch, Route } from "react-router";

import StakingBoard from "./components/StakingBoard";
import StakingIncome from "./components/StakingIncome";
import RewardsBoard from "./components/RewardsBoard";
import VestingBoard from "./components/VestingBoard";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  stakingContainer: {
    flex: 1,
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    paddingBottom: "60px",

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    fontFamily: "Poppins",
    position: "relative",
  },
});

const Staking = ({ classes }) => {
  return (
    <div className={classes.stakingContainer}>
      <Switch>
        <Route exact path={`/staking/pools`} component={StakingIncome} />
        <Route exact path={`/staking/rewards`} component={RewardsBoard} />
        <Route exact path={`/staking/vesting`} component={VestingBoard} />
        <Route path={`/staking/:address/stake`} component={StakingIncome} />
        <Route path={`/staking`} component={StakingBoard} />
      </Switch>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(Staking)));
